var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',{staticClass:"uk-nav uk-dropdown-nav"},[(_vm.table)?_c('Edit',{attrs:{"id":_vm.id}},[_vm._v("Edit")]):_vm._e(),_c('Delete',{attrs:{"id":_vm.id,"display_name":_vm.display_name,"is_leaf":false,"product_count":_vm.product_count}},[_vm._v("Delete")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }